/**
 * Created by bladron on 07/04/16.
 */
import Reflux from 'reflux';
import { PostApi } from "../api/Api";

let PostActions = {
    init: Reflux.createAction(),
    getPostBeforeDate: Reflux.createAction({asyncResult: true}),
    getMorePost: Reflux.createAction(),

    getEventsBeforeDate: Reflux.createAction({asyncResult: true}),
    getMoreEvents: Reflux.createAction(),

    getLatestGroups: Reflux.createAction({asyncResult: true}),
    getMoreGroups: Reflux.createAction(),

    getLatestLocalities: Reflux.createAction({asyncResult: true}),
    getMoreLocalities: Reflux.createAction()
};

PostActions.getPostBeforeDate.listen(function (date) {
    PostApi.getPostBeforeDate(date).then((data) => {
        this.completed(data);
    });
});

PostActions.getEventsBeforeDate.listen(function (date, excludeIds) {
    PostApi.getEvents(date, excludeIds).then((data) => {
        this.completed(data);
    });
});

PostActions.getLatestGroups.listen(function (skip) {
    PostApi.getLatestGroups(skip).then((data) => {
        this.completed(data);
    });
});

PostActions.getLatestLocalities.listen(function (skip) {
    PostApi.getLatestLocalities(skip).then((data) => {
        this.completed(data);
    });
});

export default PostActions;



// WEBPACK FOOTER //
// ./js/mywort/frontend/actions/PostActions.js